// Imports => Vendor
import axios from "axios";

// Imports => MOBX
import { makeObservable, observable, computed, action } from "mobx";

// Imports => Utilities
import {
  AcSaveState,
  AcRemoveState,
  AcIsSet,
  AcIsNull,
  AcIsUndefined,
  AcFormatErrorMessage,
} from "@opp/ui-kit";
import { AcAutoSave } from "@utils";

let app = {};

export class UserStore {
  constructor(store) {
    makeObservable(this);

    AcAutoSave(this);

    app.store = store;
  }

  @observable
    loading = {
      status: false,
      message: null,
    };

  @computed
  get is_loading() {
    return this.loading.status;
  }

  @action
    setLoading = (state, message) => {
      this.loading = {
        status: state || false,
        message,
      };
    };

  @observable
    busy = {
      status: false,
      message: null,
    };

  @computed
  get is_busy() {
    return this.busy.status;
  }

  @action
    setBusy = (state, message) => {
      this.busy = {
        status: state || false,
        message,
      };
    };

  @action
    delete = (t) => {
      this.setBusy(true);

      return app.store.api.user
        .delete()
        .then((response) => {
          let variant = "";
          let statusCode = response.status_code;

          switch (statusCode) {
            case 200:
              variant = "success";
              break;
            case 300:
              variant = "info";
              break;
            case 301:
              variant = "info";
              break;
            case 400:
              variant = "info";
              break;
            case 403:
              variant = "info";
              break;
          }

          let description = t("user.delete.status-code." + statusCode, {
            ns: "store",
            default: "You cannot delete your account"
          });

          app.store.toasters.add({
            variant: variant,
            description: description,
            delay: 1000 * 12, // Little longer delay so user can read it
          });

          this.setBusy(false);
          return response;
        })
        .catch((error) => {
          this.setBusy(false);

          if (!axios.isCancel(error)) {
            app.store.toasters.add({
              variant: "error",
              title: t("user.delete.failed", { ns: "store" }),
              description: AcFormatErrorMessage(error),
            });
          }

          if (!axios.isCancel(error)) {
            throw error;
          }
        });
    };

  @action
    set = (target, value, save = false) => {
      if (!AcIsSet(target)) return;
      if (AcIsUndefined(this[target])) return;
      if (AcIsUndefined(value)) return;

      return new Promise((resolve) => {
        this[target] = value;
        if (save) AcSaveState(target, value);
        resolve();
      });
    };

  @action
    setState = (target, property, value, save = false) => {
      if (!AcIsSet(target)) return;
      if (AcIsUndefined(this[target])) return;
      if (!AcIsSet(property)) return;
      if (AcIsUndefined(value)) return;

      this[target][property] = value;
      if (save) AcSaveState(target, value);
    };

  @action
    reset = (target, save = false) => {
      if (!AcIsSet(target)) return;
      if (AcIsUndefined(this[target])) return;

      return new Promise((resolve) => {
        this[target] = _default[target];
        if (save && AcIsNull(_default[target])) {
          AcRemoveState(target);
        } else if (save) {
          AcSaveState(target, _default[target]);
        }

        resolve();
      });
    };
}

export default UserStore;
